import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DataTables from "./DataTables"
import MetaTag from "components/Common/Meta-tag"
import PropTypes from "prop-types"

function InvestmentLeads({ isMinimal }) {
  return (
    <>
      <MetaTag title={"All InvestmentLeads"} />

      <div className={`page-content ${isMinimal ? "pt-0" : "pt-10"}`}>
        {!isMinimal && (
          <Breadcrumbs title="Dashboard" breadcrumbItem="All InvestmentLeads" />
        )}
        <Container fluid>
          <div className="container-fluid">
            <DataTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default InvestmentLeads

InvestmentLeads.propTypes = {
  isMinimal: PropTypes.any,
}
